module.exports = __webpack_public_path__ + "img/4.2a3691d4.png";